import React, {useEffect} from 'react';
import {API, Notifications} from 'pwm-shared/src/types/api/api';
import {useApi} from '../hooks/use-api';

export const NotificationContext = React.createContext<INotificationContext>({
  count: 0,
  notifications: [],
  getNotification(id: string): Promise<Notifications.NotificationsResponse | undefined> {
    return Promise.resolve(undefined);
  },
  getNotifications(): Promise<Notifications.NotificationsResponse[]> {
    return Promise.resolve([]);
  }
});

NotificationContext.displayName = 'Notification Context';

const route: Notifications.Endpoint = 'notifications';
const GetNotificationQuery: Notifications.GetNotificationQuery = 'notificationId';

export const NotificationProvider: React.FC<{children: any}> = (props) => {
  const [notifications, setNotifications] = React.useState<Notifications.NotificationsResponse[]>([]);
  const api = useApi();

  useEffect(() => {
    getNotifications().then((notifications) => {
      setNotifications(notifications);
    })
  }, []);
  const getNotifications = async (): Promise<Notifications.NotificationsResponse[]> => {
    if (!api) return [];
    const axios = api.getClient();
    if (!axios) return [];
    const {data} = await axios.get<API.Response<Notifications.NotificationsResponse[]>>(route);
    return data.data;
  }

  const getNotification = async (notificationId: string): Promise<Notifications.NotificationsResponse | undefined> => {
    if (!api) return;
    const axios = api.getClient();
    if (!axios) return;
    const {data} = await axios.get(`${route}`, {params: {[GetNotificationQuery]: notificationId}});
    return data.data;
  }

  const value: INotificationContext = {
    count: notifications.length,
    notifications,
    getNotifications,
    getNotification
  };
  return (
    <NotificationContext.Provider value={value}>
      {props.children}
    </NotificationContext.Provider>
  )
}

interface INotificationContext {
  count: number;
  notifications: Notifications.NotificationsResponse[];
  getNotifications(): Promise<Notifications.NotificationsResponse[]>;
  getNotification(id: string): Promise<Notifications.NotificationsResponse | undefined>;
}
